<template>
  <div class="metric-card">
    <div class="metric-main">
      <div class="metric-title">
        <img src="../../assets/img/arrorw.png" />
        <span>{{ title }}</span>
      </div>
      <div class="metric-value-row">
        <strong>{{ value }}</strong>
        <span>{{ unit }}</span>
      </div>
      <div class="metric-trend">
        <span>环比上月</span>
        <i :class="trendClass"></i>
        <b>{{ trendValue }}</b>
      </div>
    </div>
    <div class="metric-rate">
      <i :class="trendClass"></i>
      <strong>{{ trendValue }}</strong>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  unit: {
    type: String,
    default: "",
  },
  trendValue: {
    type: String,
    default: "",
  },
  trendDirection: {
    type: String,
    default: "up",
  },
});

const trendClass = computed(() => ({
  "trend-icon": true,
  "is-down": props.trendDirection === "down",
  "is-red": props.trendDirection === "up-red",
}));
</script>

<style lang="less" scoped>
.metric-card {
  height: 100%;
  min-width: 0;
  display: grid;
  grid-template-rows: 1.08fr 0.82fr;
  gap: 30px;
}

.metric-main,
.metric-rate {
  position: relative;
  overflow: hidden;
  border: 2px solid #1D6082;
  border-radius: 10px;
  padding: 20px 0;
  background:
    radial-gradient(circle at 80% 20%, rgba(5, 31, 61, 0.22) 0 1px, transparent 2px) 0 0 / 22px 22px,
    linear-gradient(120deg, rgba(5, 31, 61, 0.74), rgba(12, 50, 92, 0.45));
  box-shadow:
    inset 0 0 34px rgba(45, 153, 237, 0.18),
    0 0 14px rgba(28, 142, 225, 0.18);
}

.metric-main:before,
.metric-main:after,
.metric-rate:before,
.metric-rate:after {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  border-color: #5DF6F9!important;
  border-radius: 10px 0 0 0;
  //opacity: 0.92;
}

.metric-main:before,
.metric-rate:before {
  top: -3px;
  left: -2px;
  border-top: 5px solid;
  border-left: 5px solid;
}

.metric-main:after,
.metric-rate:after {
  right: -2px;
  bottom: -2px;
  border-right: 5px solid;
  border-bottom: 5px solid;
}

.metric-title {
  height: 52px;
  display: flex;
  align-items: center;
  padding: 0 28px 0;
  box-sizing: border-box;
  color: #dcecff;
  font-size: 27px;
  font-weight: bold;
  img{
    width: 40px;
    height: 35px;
    margin-right: 10px;
  }
}

.metric-arrow {
  width: 0;
  height: 0;
  margin-right: 16px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid #31aaff;
  filter: drop-shadow(0 0 8px rgba(49, 170, 255, 0.85));
}

.metric-value-row {
  //height: 100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.metric-value-row strong {
  display: block;
  color: #e7f1ff;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 60px;
  line-height: 86px;
  font-weight: bold;
  text-shadow: 0 0 18px rgba(85, 176, 255, 0.48);
}

.metric-value-row span {
  color: #e8f4ff;
  font-size: 28px;
  font-weight: bold;
  padding: 0 0 12px 14px;
}

.metric-trend {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e7f3ff;
  font-size: 25px;
  font-weight: bold;
}

.metric-trend b {
  color: #56ecac;
  font-weight: bold;
  margin-left: 10px;
}

.metric-trend .is-down + b {
  color: #ff626d;
}

.metric-trend .is-red + b {
  color: #ff626d;
}

.metric-rate {
  display: flex;
  align-items: center;
  justify-content: center;
}

.metric-rate strong {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 68px;
  line-height: 76px;
  font-weight: bold;
  text-shadow: 0 0 16px rgba(91, 190, 255, 0.4);
  background: linear-gradient(to top, #A7F5F7 20%, #ffffff);
  -webkit-background-clip: text;
  color: transparent;
}

.trend-icon {
  width: 0;
  height: 0;
  margin-left: 10px;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-bottom: 22px solid #4de6a4;
  filter: drop-shadow(0 0 8px rgba(77, 230, 164, 0.7));
}

.metric-rate .trend-icon {
  margin-left: 0;
  margin-right: 14px;
  border-left-width: 16px;
  border-right-width: 16px;
  border-bottom-width: 28px;
}

.trend-icon.is-down {
  border-bottom: 0;
  border-top: 22px solid #bfe8ff;
  filter: drop-shadow(0 0 8px rgba(191, 232, 255, 0.7));
}

.metric-rate .trend-icon.is-down {
  border-top-width: 28px;
}

.trend-icon.is-red {
  border-bottom-color: #ff5364;
  filter: drop-shadow(0 0 8px rgba(255, 83, 100, 0.72));
}
</style>
